/**
 * THE HOUSE'S SHELVES — the colour dimension of the book, in the house's order.
 * OWNER: web-frontend-engineer (moved into the core 6 September 2026, STYLIST-2,
 * so the consultation engine and the book's paging read ONE list).
 *
 * Which shelf a cloth is on is read from the one colour field the client
 * payload carries, `colourName`: `tools/import-real-cloths.mjs` writes each
 * real cloth's colour name FROM its shelf (`COLOUR_WORD`, exactly one word per
 * shelf), so for the photographed cloths this is an exact inversion. The
 * placeholder rows carry a mill's own names ("Midnight Blue", "Mid Grey", "Peat
 * Brown"); for those the first word that names a shelf decides.
 */

export const HOUSE_SHELVES = [
  'navy',
  'charcoal',
  'grey',
  'other_blues',
  'brown_earth',
  'green',
  'burgundy_red',
  'black_and_midnight',
  'stone_and_fawn',
  'natural_and_ivory',
  'statement',
] as const;

export type HouseShelf = (typeof HOUSE_SHELVES)[number];

/** The words a colour name can carry for each shelf. */
export const SHELF_WORDS: Readonly<Record<HouseShelf, readonly string[]>> = {
  navy: ['navy'],
  charcoal: ['charcoal'],
  grey: ['grey', 'slate'],
  other_blues: ['blue'],
  brown_earth: ['brown', 'tobacco'],
  green: ['green', 'olive'],
  burgundy_red: ['burgundy'],
  black_and_midnight: ['midnight', 'black'],
  stone_and_fawn: ['stone', 'fawn'],
  natural_and_ivory: ['natural', 'ivory'],
  statement: ['statement'],
};

/**
 * The shelf a colour name puts a cloth on, or `null` where no word of the name
 * names a shelf. The FIRST word that names a shelf decides.
 */
export function shelfOf(colourName: string): HouseShelf | null {
  const words = colourName.toLowerCase().split(/[^a-z]+/).filter((word) => word !== '');
  for (const word of words) {
    for (const shelf of HOUSE_SHELVES) {
      if (SHELF_WORDS[shelf].includes(word)) return shelf;
    }
  }
  return null;
}
